module.exports = __webpack_public_path__ + "static/fun-time/games/page004_game0/audio//6_bear.mp3";